module.exports = __webpack_public_path__ + "static/person-female-7907f54025f80cb8929aa9081915c8d2.png";